import { render, staticRenderFns } from "./CopyTemplateCustomer.vue?vue&type=template&id=47cd7af6&scoped=true&"
import script from "./CopyTemplateCustomer.vue?vue&type=script&lang=js&"
export * from "./CopyTemplateCustomer.vue?vue&type=script&lang=js&"
import style0 from "./CopyTemplateCustomer.vue?vue&type=style&index=0&id=47cd7af6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47cd7af6",
  null
  
)

export default component.exports